import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear token and bounce to /login
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);

// Users (admin)
export const listUsers = () => api.get("/users").then((r) => r.data);
export const createUser = (d) => api.post("/users", d).then((r) => r.data);
export const deleteUser = (id) => api.delete(`/users/${id}`).then((r) => r.data);

// Organizations
export const listOrganizations = () => api.get("/organizations").then((r) => r.data);
export const getOrganization = (id) => api.get(`/organizations/${id}`).then((r) => r.data);
export const createOrganization = (d) => api.post("/organizations", d).then((r) => r.data);
export const updateOrganization = (id, d) => api.put(`/organizations/${id}`, d).then((r) => r.data);
export const deleteOrganization = (id) => api.delete(`/organizations/${id}`).then((r) => r.data);
export const getOrganizationComparison = (id) =>
  api.get(`/organizations/${id}/comparison`).then((r) => r.data);

// Reports
export const listReports = (orgId) =>
  api.get("/reports", { params: orgId ? { organization_id: orgId } : {} }).then((r) => r.data);
export const getReport = (id) => api.get(`/reports/${id}`).then((r) => r.data);
export const createReport = (d) => api.post("/reports", d).then((r) => r.data);
export const updateReport = (id, d) => api.put(`/reports/${id}`, d).then((r) => r.data);
export const deleteReport = (id) => api.delete(`/reports/${id}`).then((r) => r.data);
export const calculateInline = (data) => api.post("/reports/calculate", data).then((r) => r.data);
export const exportReport = (id) =>
  api.get(`/reports/${id}/export`, { responseType: "blob" });
export const exportReportPdf = (id) =>
  api.get(`/reports/${id}/export-pdf`, { responseType: "blob" });

// Factors
export const getFactors = () => api.get("/factors").then((r) => r.data);

export const fmt = (v, d = 3) => {
  if (v === null || v === undefined || v === "") return "0,000";
  const n = Number(v);
  if (Number.isNaN(n)) return "0,000";
  return n.toLocaleString("tr-TR", { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const fmtInt = (v) => {
  const n = Number(v || 0);
  return n.toLocaleString("tr-TR", { maximumFractionDigits: 0 });
};
